module.exports = __webpack_public_path__ + "img/b2c.9e85e98f.png";